(() => {
  if (window.DPL006ReasonVideoLoaderV3) {
    window.DPL006ReasonVideoLoaderV3.scan(document);
    return;
  }

  const selector = 'video[data-dpl006-lazy-video]';
  const registered = new WeakSet();
  const visible = new WeakMap();
  const retryTimers = new WeakMap();
  let observer = null;

  const buttonFor = (video) => video.parentElement && video.parentElement.querySelector('[data-dpl006-play-video]');
  const setState = (video, state, showButton = false) => {
    video.dataset.playbackState = state;
    const button = buttonFor(video);
    if (button) button.hidden = !showButton;
  };
  const clearRetry = (video) => {
    const timer = retryTimers.get(video);
    if (timer) window.clearTimeout(timer);
    retryTimers.delete(video);
  };
  const showRecovery = (video, state) => {
    clearRetry(video);
    setState(video, state, true);
  };
  const ensureSource = (video) => {
    const source = video.querySelector('source[data-src]');
    if (!source) {
      showRecovery(video, 'missing-source');
      return false;
    }
    if (!source.getAttribute('src')) {
      source.setAttribute('src', source.dataset.src || '');
      video.load();
    }
    return Boolean(source.getAttribute('src'));
  };
  const scheduleRecovery = (video, state = 'stalled') => {
    clearRetry(video);
    const timer = window.setTimeout(() => {
      if (visible.get(video) && (video.paused || video.readyState < 2)) showRecovery(video, state);
    }, 2800);
    retryTimers.set(video, timer);
  };
  const attemptPlay = async (video, userInitiated = false) => {
    if (!userInitiated && !visible.get(video)) return;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    if (!ensureSource(video)) return;
    setState(video, 'loading');
    scheduleRecovery(video);
    try {
      await video.play();
      clearRetry(video);
      setState(video, 'playing');
    } catch {
      showRecovery(video, 'play-blocked');
    }
  };
  const register = (video) => {
    if (registered.has(video)) return;
    registered.add(video);
    visible.set(video, false);
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.removeAttribute('autoplay');
    setState(video, 'idle');
    video.addEventListener('playing', () => {
      clearRetry(video);
      setState(video, 'playing');
    });
    video.addEventListener('loadeddata', () => {
      if (visible.get(video)) attemptPlay(video);
    });
    video.addEventListener('canplay', () => {
      if (visible.get(video) && video.paused) attemptPlay(video);
    });
    video.addEventListener('waiting', () => scheduleRecovery(video, 'buffering'));
    video.addEventListener('stalled', () => scheduleRecovery(video, 'stalled'));
    video.addEventListener('error', () => showRecovery(video, 'media-error'));
    const button = buttonFor(video);
    if (button) button.addEventListener('click', () => attemptPlay(video, true));
    if (observer) observer.observe(video);
    else {
      visible.set(video, true);
      attemptPlay(video);
    }
  };
  const scan = (root = document) => {
    if (root.matches && root.matches(selector)) register(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(register);
  };

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        visible.set(entry.target, entry.isIntersecting);
        if (entry.isIntersecting) attemptPlay(entry.target);
        else if (!entry.target.paused) entry.target.pause();
      });
    }, { rootMargin: '240px 0px', threshold: 0.01 });
  }

  window.DPL006ReasonVideoLoaderV3 = { scan, attemptPlay };
  scan(document);
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) scan(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('pageshow', () => scan(document));
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) document.querySelectorAll(selector).forEach((video) => attemptPlay(video));
  });
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
